import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService, SessionInformationService } from 'app/core/core.module';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
    language: string;
    spanish: boolean;

    constructor(public appInfo: AppInformationService, private auth: AuthService, private router: Router, private sessionInfo: SessionInformationService) {}

    ngOnInit() {
        this.appInfo.pleaseWaitHide();
        this.spanish = this.sessionInfo.getItem('terminalLanguage', true) || false;
    }

    terminalLanguageChanged(e: any) {
        this.sessionInfo.setItem('terminalLanguage', this.spanish, true);
    }

    logout() {
        this.auth.logout();
        this.router.navigate(['/login']);
    }
}
